import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "../lib/api";
import ComingSoon from "../pages/ComingSoon";

const OPEN_PATHS = ["/terms", "/privacy"];

export default function PrelaunchGate({ children }) {
  const [state, setState] = useState(null);
  const { pathname } = useLocation();

  useEffect(() => {
    api.get("/prelaunch/status")
      .then(({ data }) => setState(data))
      .catch(() => setState({ enabled: true, unlocked: false }));
  }, []);

  if (!state) return <div className="min-h-screen bg-[#F9F7F3]" data-testid="prelaunch-loading" />;
  if (state.unlocked || OPEN_PATHS.includes(pathname)) return children;
  return <ComingSoon onUnlocked={() => setState({ ...state, unlocked: true })} />;
}
